/* @flow */

import type { $WidgetEnvConfiguration } from '../types/WidgetEnvConfiguration';
import Endpoints from 'CoreConstants/Endpoints';
import Environments from 'CoreConstants/Environments';
import HereMapsCredentials from 'CoreComponents/MapProviders/HereMaps/HereMapsCredentials';

const config: $WidgetEnvConfiguration = {
  env: Environments.ENV_DEV,
  configurationServiceEndpointInternal: Endpoints.INTERNAL.DSW.CMS.DEV,
  configurationServiceEndpointExternal: Endpoints.EXTERNAL.CMS.DEV,
  dealerServiceEndpointInternal: Endpoints.INTERNAL.DSW.DMS.DEV,
  dealerServiceEndpointExternal: Endpoints.EXTERNAL.DMS.DEV,
  mapProviders: {
    hereMaps: {
      appId: HereMapsCredentials.DEV_APP_ID,
      appCode: HereMapsCredentials.DEV_APP_CODE,
      useCIT: true
    }
  }
};

export default config;
